import React from "react";
import PropTypes from "prop-types";

import CoreStats from "core/Stats";
import BodyText from "core/BodyText";

import { StatsContainer, StatsSecondaryInfoText } from "./styles";

import colors from "core/colors";

const salesTypeLabels = {
    fullRes: "Full-Res",
    large: "Large",
    premium: "Premium",
    standard: "Standard"
};

const Stats = ({ totals }) => {
    const {
        totalEarned,
        totalPaid,
        fullResSales = 0,
        largeSales = 0,
        premiumPhotoSales = 0,
        standardPhotoSales = 0,
        freeDownloadCount = 0
    } = totals;

    const paidSales = {
        [salesTypeLabels.fullRes]: fullResSales,
        [salesTypeLabels.large]: largeSales,
        [salesTypeLabels.premium]: premiumPhotoSales,
        [salesTypeLabels.standard]: standardPhotoSales
    };

    const totalPaidSales = Object.values(paidSales).reduce(
        (acc, val) => acc + val
    );

    const paidSalesDescription = Object.entries(paidSales)
        .filter(([key, value]) => value > 0)
        .map(([key, value]) => `${value} ${key}`)
        .join(", ");

    return (
        <StatsContainer>
            <CoreStats
                heading={`$${totalEarned}`}
                subheading="REVENUE"
                secondaryInfo={[
                    <BodyText
                        key={1}
                        size="lg"
                        copyColor={colors.alternative.lightMode.pine}
                    >
                        Paid {`$${totalPaid}`}
                    </BodyText>,
                    <StatsSecondaryInfoText key={0}>
                        Queued {`$${(totalEarned - totalPaid).toFixed(2)}`}
                    </StatsSecondaryInfoText>
                ]}
            />
            <CoreStats
                heading={totalPaidSales.toString()}
                subheading="SALES"
                secondaryInfo={[
                    <StatsSecondaryInfoText key={0}>
                        {paidSalesDescription}
                    </StatsSecondaryInfoText>
                ]}
            />
            <CoreStats
                heading={freeDownloadCount.toString()}
                subheading="COMPS"
                secondaryInfo={[
                    <StatsSecondaryInfoText key={0}>
                        Comp and/or public domain
                    </StatsSecondaryInfoText>
                ]}
            />
        </StatsContainer>
    );
};

Stats.propTypes = {
    totals: PropTypes.object.isRequired
};

export default Stats;
